import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import * as serviceWorker from './utils/serviceWorker';
import './styles/global.css';
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);

// Register the service worker for PWA capabilities
// If you want your app to work offline and load faster, change to register()
serviceWorker.register();